import { ROUTES } from "app/routes/constants";
import { User } from "types/user";

export const getDefaultRoute = (role: User["role"]) => {
    return role === "ADMIN" ? ROUTES.ADMIN.OUR_SOCIAL_LIFE.PATH : ROUTES.DASHBOARD.HOME;
};
